var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "table-col-member-type-expired-in-day" }, [
    _c("span", { staticStyle: { "white-space": "nowrap" } }, [
      _vm._v("\n        " + _vm._s(_vm.prettyFormatForexpiredInDays) + "\n    ")
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }